// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form__group {
    position: relative;
    padding: 15px 0 0;
    margin-top: 10px;
    width: 100%;
  }
  
  .form__field {
    font-family: inherit;
    width: 100%;
    border: 0;
    border-bottom: 1px solid #000;
    outline: 0;
    font-size: 15px;
    color: #000;
    padding: 7px 0;
    background: transparent;
    transition: border-color 0.2s;
  }
  .form__field::placeholder {
    color: #aaa;
  }
  .form__field:placeholder-shown ~ .form__label {
    font-size: 1rem;
    cursor: text;
    top: 20px;
  }
  
  .form__label {
    position: absolute;
    top: -8px;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #000;
  }
  
  .form__field:focus {
    padding-bottom: 6px;
    font-weight: 700;
    border-width: 3px;
    border-image: linear-gradient(to right, #9b9b9b, #9b9b9b);
    border-image-slice: 1;
  }
  .form__field:focus ~ .form__label {
    position: absolute;
    top: -8px;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #9b9b9b;
    font-weight: 700;
  }
  
  /* reset input */
  .form__field:required, .form__field:invalid {
    box-shadow: none;
  }
  .color_button{
      background-color: #000;
      color:#fff;
      border: 1px solid!important;
  }
  .child_class{
    box-shadow: 0 4px 8px 0 #212529, 0 6px 20px 0 #212529;
  }
  @media only screen and (min-width:500px){
  .child_class{
    position: relative;
    width: 100%;
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
    color:#fff
  }
}

.child_class{
  width: 50%;
  height: auto;
}
@media only screen and (max-width: 600px) {
  .child_class {
    width: 100%;
    height: auto;
  }
}
@media only screen and (max-width:499px){
  .child_class{
    position: relative;
    /* width: 50%; */
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
    color:#fff;
  }
}
.child_class-login{
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5%;
}

@media only screen and (min-width:500px){
  .child_class__{
    position: relative;
    width: 85%;
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
    color:#fff
  }
}
@media only screen and (max-width:499px){
  .child_class__{
    position: relative;
    /* width: 50%; */
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
    color:#fff
  }
}
  
  /* demo */


  .date-container {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  
  .date-container input {
    /* padding: 10px; */
    font-size: 16px;
    width: 100%;
    background: transparent;
    position: relative;
    z-index: 1;
    color: transparent; /* Hide default text */
  }
  
  .date-container input:focus,
  .date-container input.has-value {
    color: #000; /* Show text when user selects a date */
  }
  
  .date-container .custom-placeholder {
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translateY(-50%);
    color: #999;
    pointer-events: none;
    transition: all 0.3s ease;
  }
  
  .date-container input.has-value + .custom-placeholder {
    display: none;
  }
  `, "",{"version":3,"sources":["webpack://./src/CSS/Signup.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,SAAS;IACT,6BAA6B;IAC7B,UAAU;IACV,eAAe;IACf,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,6BAA6B;EAC/B;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yDAAyD;IACzD,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;EAClB;EACA;MACI,sBAAsB;MACtB,UAAU;MACV,2BAA2B;EAC/B;EACA;IACE,qDAAqD;EACvD;EACA;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,OAAO;IACP,+BAA+B;IAC/B;EACF;AACF;;AAEA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,+BAA+B;IAC/B,UAAU;EACZ;AACF;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,OAAO;IACP,+BAA+B;IAC/B;EACF;AACF;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,+BAA+B;IAC/B;EACF;AACF;;EAEE,SAAS;;;EAGT;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,kBAAkB,EAAE,sBAAsB;EAC5C;;EAEA;;IAEE,WAAW,EAAE,uCAAuC;EACtD;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf","sourcesContent":[".form__group {\n    position: relative;\n    padding: 15px 0 0;\n    margin-top: 10px;\n    width: 100%;\n  }\n  \n  .form__field {\n    font-family: inherit;\n    width: 100%;\n    border: 0;\n    border-bottom: 1px solid #000;\n    outline: 0;\n    font-size: 15px;\n    color: #000;\n    padding: 7px 0;\n    background: transparent;\n    transition: border-color 0.2s;\n  }\n  .form__field::placeholder {\n    color: #aaa;\n  }\n  .form__field:placeholder-shown ~ .form__label {\n    font-size: 1rem;\n    cursor: text;\n    top: 20px;\n  }\n  \n  .form__label {\n    position: absolute;\n    top: -8px;\n    display: block;\n    transition: 0.2s;\n    font-size: 1rem;\n    color: #000;\n  }\n  \n  .form__field:focus {\n    padding-bottom: 6px;\n    font-weight: 700;\n    border-width: 3px;\n    border-image: linear-gradient(to right, #9b9b9b, #9b9b9b);\n    border-image-slice: 1;\n  }\n  .form__field:focus ~ .form__label {\n    position: absolute;\n    top: -8px;\n    display: block;\n    transition: 0.2s;\n    font-size: 1rem;\n    color: #9b9b9b;\n    font-weight: 700;\n  }\n  \n  /* reset input */\n  .form__field:required, .form__field:invalid {\n    box-shadow: none;\n  }\n  .color_button{\n      background-color: #000;\n      color:#fff;\n      border: 1px solid!important;\n  }\n  .child_class{\n    box-shadow: 0 4px 8px 0 #212529, 0 6px 20px 0 #212529;\n  }\n  @media only screen and (min-width:500px){\n  .child_class{\n    position: relative;\n    width: 100%;\n    left: 50%;\n    top:50%;\n    transform: translate(-50%,-50%);\n    color:#fff\n  }\n}\n\n.child_class{\n  width: 50%;\n  height: auto;\n}\n@media only screen and (max-width: 600px) {\n  .child_class {\n    width: 100%;\n    height: auto;\n  }\n}\n@media only screen and (max-width:499px){\n  .child_class{\n    position: relative;\n    /* width: 50%; */\n    left: 50%;\n    top:50%;\n    transform: translate(-50%,-50%);\n    color:#fff;\n  }\n}\n.child_class-login{\n  width: 50%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 5%;\n}\n\n@media only screen and (min-width:500px){\n  .child_class__{\n    position: relative;\n    width: 85%;\n    left: 50%;\n    top:50%;\n    transform: translate(-50%,-50%);\n    color:#fff\n  }\n}\n@media only screen and (max-width:499px){\n  .child_class__{\n    position: relative;\n    /* width: 50%; */\n    left: 50%;\n    top:50%;\n    transform: translate(-50%,-50%);\n    color:#fff\n  }\n}\n  \n  /* demo */\n\n\n  .date-container {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n  }\n  \n  .date-container input {\n    /* padding: 10px; */\n    font-size: 16px;\n    width: 100%;\n    background: transparent;\n    position: relative;\n    z-index: 1;\n    color: transparent; /* Hide default text */\n  }\n  \n  .date-container input:focus,\n  .date-container input.has-value {\n    color: #000; /* Show text when user selects a date */\n  }\n  \n  .date-container .custom-placeholder {\n    position: absolute;\n    top: 50%;\n    left: 0px;\n    transform: translateY(-50%);\n    color: #999;\n    pointer-events: none;\n    transition: all 0.3s ease;\n  }\n  \n  .date-container input.has-value + .custom-placeholder {\n    display: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
